import {GradientCanvas} from "../components/GradientCanvas/GradientCanvas";

const Layout = ({children}) => {
    return (
        <div className="main-cointainer">
            <GradientCanvas />
            {children}
        </div>
    );
};

export default Layout;